<template>
    <div>
        <modal-add-map ref="addMapDialog"/>
        <modal-edit-map ref="editMapDialog"/>
        <v-row>
            <v-col cols="12">
                <v-btn @click="showAddRedirectModal()">Dodaj mapę</v-btn>
                <v-list>
                  <v-list-item>1. <a href="https://www.google.com/maps/d/u/0/" target="_blank">Stwórz mapę na google.com</a></v-list-item>
                  <v-list-item>2. Po dodaniu punktów kliknij Udostępnij > nadaj nazwę i opis</v-list-item>
                  <v-list-item>3. Zaznacz: każda osoba mjąca ten link może zobaczyć</v-list-item>
                  <v-list-item>4. 3 kropki: umieść tę mapę na stronie > odnacz switch umieść w nagłówku ...</v-list-item>
                </v-list>
                <data-table
                        ref="table"
                        :headers="headers"
                        :items="maps"
                        :options.sync="options"
                        :loading="loading"
                        class="elevation-1 row-pointer"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                        small
                        :disabled="!!item.processed"
                        @click="showEditRedirectModal(item, $event)"
                        title="Edytuj"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                        small
                        :disabled="!!item.processed"
                        @click="onRemoveBtnTriggered(item, $event)"
                        title="Usuń"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import api from '../services/api';
    import DataTable from "@/components/data-table/DataTable";
    import formatters from '@/mixins/formatters';
    import permissions from '@/mixins/permissions';
    import ModalAddMap from "@/components/ModalAddMap.vue";
    import ModalEditMap from "@/components/ModalEditMap.vue";

    export default {
        mixins: [
            formatters,
            permissions,
        ],
        components: {
          ModalEditMap,
          ModalAddMap,
          DataTable,
        },
        data () {
            return {
                maps: [],
                loading: true,
                options: {},
                headers: [
                    { text: 'ID', value: 'id', sortable: false },
                    { text: 'Nazwa', value: 'name', sortable: false },
                    { text: 'Akcje', value: 'actions', sortable: false },
                ],
                dialogRemove: false,
            }
        },
        methods: {
            async getMaps() {
                this.loading = true;

                const response = await api.get('/api/maps', {});
                this.loading = false;

                this.maps = response.data;
            },
            remove(item, event = null) {
                if (this.loading) {
                  return;
                }

                let $icon = null;

                if (event) {
                  $icon = event.target;

                  // The following line is required to avoid triggering onRowClicked() method.
                  event.cancelBubble = true;
                }

                if (item.processed) {
                  return;
                }

                const id = item.id;
                item.processed = true;

                if ($icon) {
                  $icon.disabled = true;
                  $icon.classList.add('v-icon--disabled');
                }

                api.delete(`/api/maps/${id}`)
                    .then(() => {
                      this.getMaps();

                      this.$root.$emit('notifySuccess', {
                        html: `Mapa została usunięta.`,
                      });
                    })
                    .catch((error) => {
                      if ($icon) {
                        $icon.disabled = false;
                        $icon.classList.remove('v-icon--disabled');
                      }

                      this.$root.$emit('notifyError', {
                        html: 'Nie udało się usunąć mapy.',
                        error,
                      });
                    })
                    .finally(() => {
                      delete item.processed;
                });
            },
            onRemoveBtnTriggered(item, event) {
              this.stopRowClickPropagation(event);
              this.remove(item, event);
            },
            stopRowClickPropagation(event) {
              // The following line is required to avoid triggering onRowClicked() method.
              event.cancelBubble = true;
              event.stopPropagation();
            },
            async showAddRedirectModal() {
              this.$refs.addMapDialog
                  .open()
            },
            async showEditRedirectModal(item) {
              this.$refs.editMapDialog
                  .open(item)
            },
        },
        created() {
          this.getMaps();
        }
    }
</script>
